import React from 'react';
import { Link } from 'react-router-dom';
import Banner from '../components/Banner';
import Footer from '../components/Footer';
import styles from './Home.module.css';


// Project images
import RocketImg from '../media/rocket.png';
import RobotImg from '../media/robot.png';
import AimiImg from '../media/aimi.png';
import GoKartImg from '../media/gokart.png';
import BattlebotImg from '../media/battlebot.png';

const Home = () => {
    return (
        <div className='Page Home'>
            <Banner></Banner>
            <section>
                {/* <h1 className={styles.title}>Projects</h1> */}
                <div className={styles.projectsList}>
                    <Link to="/projects/rocket">
                        <div className={styles.project}>
                            <img src={RocketImg} alt="Rocket Project" className={styles.projectImage} />
                            <div className={styles.projectTitle}><h2>Hybrid Rocket "Prometheus"</h2></div>
                        </div>
                    </Link>

                    <Link to="/projects/robot">
                        <div className={styles.project}>
                            <img src={RobotImg} alt="Robot Project" className={styles.projectImage} />
                            <div className={styles.projectTitle}><h2>3lb Combat Robot "Arpox"</h2></div>
                        </div>
                    </Link>
                    <Link to="/projects/aimi">
                        <div className={styles.project}>
                            <img src={AimiImg} alt="AIMi Consumer Toy project" className={styles.projectImage} />
                            <div className={styles.projectTitle}><h2>AIMi Consumer Toy</h2></div>
                        </div>
                    </Link>
                    <Link to="/projects/battlebot">
                        <div className={styles.project}>
                            <img src={BattlebotImg} alt="Battlebot Project" className={styles.projectImage} />
                            <div className={styles.projectTitle}><h2>30lb Combat Robot "Apollo"</h2></div>
                        </div>
                    </Link>
                    <Link to="/projects/skull-crusher">
                        <div className={styles.project}>
                            <img
                                src="/projects/skull-crusher/media/assets/full-robot-cad.png"
                                alt="Full-robot CAD rendering of the 30lb combat robot Skull Crusher"
                                className={styles.projectImage}
                            />
                            <div className={styles.projectTitle}><h2>30lb Combat Robot "Skull Crusher"</h2></div>
                        </div>
                    </Link>
                    <Link to="/projects/gokart">
                        <div className={styles.project}>
                            <img src={GoKartImg} alt="Go Kart Project" className={styles.projectImage} />
                            <div className={styles.projectTitle}><h2>Go Karts (Gas & Electric)</h2></div>
                        </div>
                    </Link>

                </div>
            </section>
            <Footer></Footer>
        </div>
    );
};

export default Home;
